import { SVGProps, Ref, forwardRef } from 'react';

export const RotateRightOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m7.124 5.131-.99-.99.872-.871c-.907.008-1.62.033-2.204.111-.83.112-1.294.32-1.63.656-.337.336-.545.801-.656 1.631-.115.85-.116 1.973-.116 3.564v.1H1V9.18c0-1.527 0-2.744.128-3.698.133-.986.413-1.795 1.053-2.435s1.45-.92 2.435-1.053c.667-.09 1.46-.117 2.398-.125l-.88-.88.99-.989L9.69 2.566z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 11c0-4.375-.625-5-5-5s-5 .625-5 5 .625 5 5 5 5-.625 5-5m-1.4 0c0-1.083-.04-1.831-.142-2.368-.098-.523-.23-.705-.307-.783-.078-.077-.26-.209-.783-.307C11.83 7.44 11.083 7.4 10 7.4s-1.831.04-2.368.142c-.523.098-.705.23-.783.307-.077.078-.209.26-.307.783C6.44 9.17 6.4 9.917 6.4 11s.04 1.831.142 2.368c.098.523.23.705.307.783.078.077.26.209.783.307.537.101 1.285.142 2.368.142s1.831-.04 2.368-.142c.523-.098.705-.23.783-.307.077-.078.209-.26.307-.783.101-.537.142-1.285.142-2.368"
            fill="currentColor"
        />
    </svg>
));
RotateRightOutlinedSize16Glyph.displayName = 'RotateRightOutlinedSize16Glyph';
